import { createAction } from "redux-actions";
import { UserSetupConstants } from "../constants/userSetup.constants";

export const updateUserSetupProperty = createAction(
    UserSetupConstants.UPDATE_USER_SETUP_PROPERTY
);

export const completeUserSetup = createAction(
    UserSetupConstants.COMPLETE_USER_SETUP
);

export const completeUserSetupSuccess = createAction(
    UserSetupConstants.COMPLETE_USER_SETUP_SUCCESS
);

export const completeUserSetupFailure = createAction(
    UserSetupConstants.COMPLETE_USER_SETUP_FAILURE
);



// WEBPACK FOOTER //
// ./src/actions/userSetup.actions.js